import React from 'react';
import './styles.scss';

const HomePage = () => (
  <div className="mainPage" />
);

export default HomePage;
